<template>
<div style="width: 100%;height: 100%">
  <div style="height: 50px">
    <el-input prefix-icon="el-icon-search" placeholder="输入搜索组织" v-model="filterText" clearable></el-input>
  </div>
  <div style="height: calc(100% - 55px);">
    <el-tree class="filter-tree" show-checkbox :data="treeData" :props="defaultProps" node-key="id"
             :default-expanded-keys="expandedKeys" :default-checked-keys="isFirst"
             @check-change="handleCheckChange" :filter-node-method="filterNode" ref="treeData">
      <template slot-scope="{ node, data }">
               <span class="custom-tree-node">
                 <i v-if="data.entity_id !== 0" class="el-icon-office-building"></i>
                   <span>{{ data.name }}</span>
                </span>
      </template>
    </el-tree>
  </div>
</div>
</template>
<script>
import {queryorg} from '../../api/organizer'

export default {
  name: 'treeData',
  data () {
    return {
      orgData: [],
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      expandedKeys: [],
      isFirst: []
    }
  },
  created () {
  },
  mounted () {
    this.getOrgData()
  },
  watch: {
    filterText (val) {
      this.$refs.treeData.filter(val)
    }
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    handleCheckChange () {
      this.isFirst = this.$refs.treeData.getCheckedKeys()
      let obj = {
        type: 'check',
        orgids: this.isFirst
      }
      this.$emit('checkChange', obj)
    },
    // 组织
    getOrgData () {
      this.expandedKeys = []
      this.treeData = []
      queryorg().then(res => {
        let orgData = res.data.org.filter(item => {
          if (item.org_type === 0) {
            return item
          }
        })
        // 所属组织
        let lastLevel = 100
        const arr = orgData
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level < lastLevel) {
            lastLevel = arr[i].level
          }
        }
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level === lastLevel) {
            this.treeData.push(arr[i])
          }
        }
        for (let i = 0; i < this.treeData.length; i++) {
          this.expandedKeys.push(this.treeData[i].id)
          const child = this.arrayToNode(arr, this.treeData[i].id)
          if (child.length !== 0) {
            this.treeData[i].child = child
          }
        }
        let obj = {
          type: 'data',
          orgData: orgData,
          treeData: this.treeData
        }
        this.$emit('checkChange', obj)
      }).catch(() => {
        this.loading = false
      })
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/treeData/treeData.vue